import { h, Component } from 'preact'
import cn from 'classnames'
import CircleButton from '../CircleButton'
import MenuList from '../MenuList'
import { OutsideClickWrapper } from '../OutsideClickWrapper'
import s from './Menu.css'

interface iState {

}

class Menu extends Component<{}, iState> {
  state = {
    isVisible: false
  }

  handleMenu = () => {
    this.setState({
      isVisible: !this.state.isVisible
    })
  }

  render () {
    const { children } = this.props
    const { isVisible } = this.state

    return (
      <OutsideClickWrapper
        className={s.Menu}
        handler={this.handleMenu}
        disabled={!isVisible}
      >
        <CircleButton
          className={cn({
            [s.Menu__button_active]: isVisible
          })}
          onClick={this.handleMenu}
        >
          <i className={s.Menu__icon}/>
        </CircleButton>

        {isVisible && (
          <MenuList>
            {children}
          </MenuList>
        )}
      </OutsideClickWrapper>
    )
  }
}

export default Menu
